import { createRouter, createWebHistory } from "vue-router";

// 연결할 각 컴포넌트 import (src/views폴더 아래 컴포넌트들 생성해둠)
//import ErrorPage from "@/views/ErrorPage";
import HomePage from "@/views/HomePage";
import seesSysmind from "@/components/sees/seesSysmind";
import seesJobmind from "@/components/sees/seesJobmind";
import seesCronmind from "@/components/sees/seesCronmind";
import noticeVue from "@/components/common/noticeVue";
import cubeOne from "@/components/product/cubeOne";
import conversionVue from "@/components/product/conversionVue";
import ediPlatform from "@/components/product/ediPlatform";
import ediService from "@/components/product/ediService";
import ediBusiness from "@/components/product/ediBusiness";
import sharePlex from "@/components/product/quest/sharePlex";
import erwinVue from "@/components/product/quest/erwinVue";
import liveReorg from "@/components/product/quest/liveReorg";
import adSecure from "@/components/product/quest/adSecure";
import toadVue from "@/components/product/quest/toadVue";
import companyVue from "@/components/common/companyVue";
import referenceVue from "@/components/common/referenceVue";
import privacyVue from "@/components/common/privacyVue";
import serviceVue from "@/components/common/serviceVue";
import linkRaiVue from "@/components/product/linkrai/linkRaiVue";

const base_path = "";

// 라우터 설계
const routes = [
  {
    path: "/",
    name: "homePage",
    component: HomePage,
  },
  {
    path: `${base_path}`,
    name: "homePage",
    component: HomePage,
  },
  {
    path: `${base_path}/sees/seesJobmind`,
    component: seesJobmind,
    meta: {
      title: "배치(잡) 스케줄러 솔루션",
    },
  },
  {
    path: `${base_path}/sees/seesSysmind`,
    component: seesSysmind,
    meta: {
      title: "서버 운영 자동화 솔루션",
    },
  },
  {
    path: `${base_path}/sees/seesCronmind`,
    component: seesCronmind,
    meta: {
      title: "크론탭 관리 솔루션",
    },
  },
  {
    path: `${base_path}/common/noticeVue`,
    component: noticeVue,
  },
  {
    path: `${base_path}/product/cubeOne`,
    component: cubeOne,
    meta: {
      title: "DB암호화, 비정형 암호화 솔루션",
    },
  },
  {
    path: `${base_path}/product/conversionVue`,
    component: conversionVue,
    meta: {
      title: "DB, APPLICATION 마이그레이션",
    },
  },
  {
    path: `${base_path}/product/ediplatform`,
    component: ediPlatform,
  },
  {
    path: `${base_path}/product/ediService`,
    component: ediService,
  },
  {
    path: `${base_path}/product/ediBusiness`,
    component: ediBusiness,
  },
  {
    path: `${base_path}/quest/sharePlex`,
    component: sharePlex,
    meta: {
      title: "데이터베이스 CDC 솔루션",
    },
  },
  {
    path: `${base_path}/quest/erwinVue`,
    component: erwinVue,
  },
  {
    path: `${base_path}/quest/liveReorg`,
    component: liveReorg,
    meta: {
      title: "데이터베이스 CDC 솔루션",
    },
  },
  {
    path: `${base_path}/quest/adSecure`,
    component: adSecure,
    meta: {
      title: "Active Directory 관리 솔루션",
    },
  },
  {
    path: `${base_path}/quest/toadVue`,
    component: toadVue,
    meta: {
      title: "DBMS 관리 프로그램",
    },
  },
  {
    path: `${base_path}/linkrai/linkRaiVue`,
    component: linkRaiVue,
    meta: {
      title: "linkRai",
    },
  },
  {
    path: `${base_path}/common/companyVue`,
    component: companyVue,
  },
  {
    path: `${base_path}/common/referenceVue`,
    component: referenceVue,
  },
  { path: `${base_path}/common/privacyVue`, component: privacyVue },
  { path: `${base_path}/common/serviceVue`, component: serviceVue },
  {
    path: "/:pathMatch(.*)",
    name: "not-found",
    component: HomePage,
  },
];

// 라우터 생성
const router = createRouter({
  history: createWebHistory(""),
  routes,
  scrollBehavior(to) {
    //console.log("Scrolling...", to, from, savedPosition);

    if (to.hash) {
      //console.log("Scrolling to hash:", to.hash);
      setTimeout(() => {
        window.scrollTo({
          top: document.querySelector(to.hash).offsetTop - 100,
          //   behavior: "smooth",
        });
      }, 300);
    } else {
      //console.log("Scrolling to top");
      return new Promise((resolve) => {
        setTimeout(() => resolve({ top: 0, behavior: "smooth" }), 300);
      });
    }
  },
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "oncrewsoft";
  next();
});

// 라우터 추출 (main.js에서 import)
export default router;
